module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_77-f2ef20805cd72c40042c59f734a9a8fd.png";